import { ANIMAL } from './menus/animal'
import { FISHING_MENU } from './menus/fishing'
import { LIVE_CASINO_MENUS } from './menus/live-casino'
import { LOTTERY_MENUS } from './menus/lottery'
import { OTHER_MENUS } from './menus/other'
import { SLOT_MENUS } from './menus/slot'
import { SPORT_BETTING_MENUS } from './menus/sport-betting'
import { TABLE_GAME_MENUS } from './menus/table-game'
import { VIRTUAL_SPORTS_MENUS } from './menus/virtual-sports'
import ARTICLE_CONTENT_1_ITEMS from './articles/article-content-1.json'
import ARTICLE_CONTENT_2_ITEMS from './articles/article-content-2.json'
import ARTICLE_CONTENT_3_ITEMS from './articles/article-content-3.json'
import JACKPOT_CONTENT from './cms/jackpot-content.json'
import VIDEO_CONTENT_1 from './cms/video-content-1.json'
import VIDEO_CONTENT_2 from './cms/video-content-2.json'
import ARTICLE_CONTENT_4 from './cms/article-content-4.json'
import FEATURE_CONTENT_3 from './cms/feature-content-3.json'
import FEATURE_CONTENT_1 from './cms/feature-content-1.json'
import FEATURE_CONTENT_1_DESKTOP from './cms/feature-content-1-desktop.json'
import FEATURE_CONTENT_2 from './cms/feature-content-2.json'
import FEATURE_CONTENT_2_DESKTOP from './cms/feature-content-2-desktop.json'
import PROMOTION_CONTENT from './cms/promotion-content.json'
import TOP_DEPOSIT_RANKING from './cms/top-deposit-ranking.json'
import UNLUCKY_WINNER from './cms/unlucky-winner.json'
import RECENT_WINNER from './cms/recent-winners.json'
import TOP_WINNER from './cms/top-winner.json'
import PARTNER_ICON from './cms/partner-icon.json'
import SLIDER_CONTENT_DESKTOP_JSON from './cms/slider-content-desktop.json'
import SLIDER_CONTENT_DESKTOP_FREE from './cms/slider-content-desktop-free-theme.json'
import TERM_AND_CONDITIONS from './cms/term-and-condition.json'
import FLOATING_ICONS from './cms/floating-icons.json'
import ANNOUNCEMENT_CONTENT from './cms/announcement.json'
import DESKTOP_SPLASH_SCREEN from './cms/desktop-splash-screen.json'
import SLIDER_CONTENT_MOBILE from './cms/slider-content-mobile.json'

export const DESKTOP_BACKGROUND = {
  data: {
    _id: '638069356dfcc20df4b9daf3',
    currency: 'thb',
    title: {},
    link: {},
    description: {},
    is_visible: true,
    is_active: true,
    component_code: 'DesktopBackground',
    image_path: {
      'en-US': 'demo/desktop-background-en.png',
      'th-TH': 'demo/desktop-background-th.png',
      'zh-CN': 'demo/desktop-background-ch.png'
    },
    is_default: false,
    platform: ['desktop'],
    is_sequenceable: false,
    items: []
  }
}
export const DESKTOP_BACKGROUND_FREE_THEME = {
  data: {
    _id: '638069356dfcc20df4b9daf3',
    currency: 'thb',
    title: {},
    link: {},
    description: {},
    is_visible: true,
    is_active: true,
    component_code: 'DesktopBackground',
    image_path: {
      'en-US': 'demo/desktop-background-free-en.png',
      'th-TH': 'demo/desktop-background-free-th.png',
      'zh-CN': 'demo/desktop-background-free-ch.png'
    },
    is_default: false,
    platform: ['desktop'],
    is_sequenceable: false,
    items: []
  }
}

export const CMS_HOME_COMPONENT = {
  data: [
    {
      _id: '63803f6796d9fdac43125a3d',
      currency: 'thb',
      title: {},
      link: {},
      description: {},
      is_visible: true,
      is_active: true,
      component_code: 'HeaderLogo',
      image_path: {
        'en-US': 'demo/logo.png',
        'th-TH': 'demo/logo.png',
        'zh-CN': 'demo/logo.png'
      },
      is_default: false,
      platform: ['desktop', 'mobile'],
      is_sequenceable: false,
      items: []
    },
    JACKPOT_CONTENT,
    VIDEO_CONTENT_1,
    FEATURE_CONTENT_3,
    { ...DESKTOP_BACKGROUND.data },
    FEATURE_CONTENT_2,
    FEATURE_CONTENT_2_DESKTOP,
    PROMOTION_CONTENT,
    TOP_DEPOSIT_RANKING,
    UNLUCKY_WINNER,
    VIDEO_CONTENT_2,
    RECENT_WINNER,
    TOP_WINNER,
    FEATURE_CONTENT_1,
    FEATURE_CONTENT_1_DESKTOP,
    DESKTOP_SPLASH_SCREEN,
    ANNOUNCEMENT_CONTENT,
    SLIDER_CONTENT_MOBILE
  ]
}

export const CMS_FOOTER_COMPONENT = {
  data: [
    TERM_AND_CONDITIONS,
    {
      _id: '6380448f36a38c352f5c75ec',
      currency: 'thb',
      title: {},
      link: {},
      description: {
        'en-US': 'Please gamble responsibly',
        'th-TH': 'โปรดเล่นการพนันอย่างมีความรับผิดชอบ',
        'zh-CN': 'l请理性博彩'
      },
      is_visible: true,
      is_active: true,
      component_code: 'GamingInformation',
      image_path: {
        'en-US': 'demo/18plus.png',
        'th-TH': 'demo/18plus.png',
        'zh-CN': 'demo/18plus.png'
      },
      is_default: false,
      platform: ['desktop', 'mobile'],
      is_sequenceable: false,
      items: []
    },
    {
      _id: '63803f9b96d9fdac43125a4a',
      currency: 'thb',
      title: {},
      link: {},
      description: {},
      is_visible: true,
      is_active: true,
      component_code: 'FooterLogo',
      image_path: {
        'en-US': 'demo/logo.png',
        'th-TH': 'demo/logo.png',
        'zh-CN': 'demo/logo.png'
      },
      is_default: false,
      platform: ['desktop'],
      is_sequenceable: false,
      items: []
    },
    PARTNER_ICON,
    {
      _id: '638af9327ee6abd1b3c80e4d',
      currency: 'thb',
      title: {
        'en-US': 'Our rules',
        'th-TH': 'กฎระเบียบของเว็บ',
        'zh-CN': '网站规定',
        'en-US-slug': 'our-rules',
        'th-TH-slug': 'กฎระเบยบของเวบ',
        'zh-CN-slug': '网站规定'
      },
      menubar_icon: null,
      link: {},
      description: {
        'en-US': 'Our Rules',
        'th-TH': 'กฎระเบียบของเว็บ',
        'zh-CN': '网站规定'
      },
      is_visible: true,
      is_active: true,
      component_code: 'ArticleContent2',
      is_default: false,
      platform: ['desktop', 'mobile'],
      is_sequenceable: false,
      items: ARTICLE_CONTENT_2_ITEMS
    },
    {
      _id: '638d6ec9bb21e0a209f791a5',
      currency: 'thb',
      title: {
        'en-US': 'Slot',
        'th-TH': 'สล็อต ',
        'zh-CN': '老虎机 ',
        'en-US-slug': 'slot',
        'th-TH-slug': 'สลอต-',
        'zh-CN-slug': '老虎机-'
      },
      menubar_icon: null,
      link: {},
      description: {
        'en-US': 'Slot rules',
        'th-TH': 'กฎสล็อต ',
        'zh-CN': '老虎机规则'
      },
      is_visible: true,
      is_active: true,
      component_code: 'ArticleContent3',
      is_default: false,
      platform: ['desktop', 'mobile'],
      is_sequenceable: false,
      items: ARTICLE_CONTENT_3_ITEMS
    },
    ARTICLE_CONTENT_4,
    {
      _id: '63bfb40f5b80bb950e648192',
      currency: 'thb',
      title: {
        'en-US': 'Live casino',
        'th-TH': 'กฎคาสิโนสด',
        'zh-CN': '真人娱乐场',
        'en-US-slug': 'live-casino',
        'th-TH-slug': 'กฎคาสโนสด',
        'zh-CN-slug': '真人娱乐场'
      },
      menubar_icon: null,
      link: {},
      description: {
        'en-US': 'Live tournamet rules and regulations',
        'th-TH': 'กฎและเงื่อนไขของคาสิโนสด',
        'zh-CN': '真人娱乐场规则和条款'
      },
      is_visible: true,
      is_active: true,
      component_code: 'ArticleContent1',
      is_default: false,
      platform: ['desktop', 'mobile'],
      is_sequenceable: false,
      items: ARTICLE_CONTENT_1_ITEMS
    }
  ]
}

export const MENU_BAR_COMPONENT = {
  data: [
    {
      _id: '63806c8e40b4a5aea422f043',
      currency: 'thb',
      title: {
        'th-TH': 'สล็อต',
        'en-US': 'Slot',
        'zh-CN': '老虎机'
      },
      link: {},
      description: {},
      is_visible: true,
      is_active: true,
      block_type: 1,
      is_default: false,
      menubar_icon: 'demo/games/v2/slot.png',
      sequence: 2,
      items: SLOT_MENUS,
      platform: ['desktop', 'mobile'],
      component_code: 'Menubar2'
    },
    {
      _id: '63806c8640b4a5aea422f02f',
      currency: 'thb',
      title: {
        'th-TH': 'คาสิโนสด',
        'en-US': 'Live Casino',
        'zh-CN': '真人娱乐场'
      },
      link: {},
      description: {},
      is_visible: true,
      is_active: true,
      is_default: false,
      block_type: 1,
      image_path: {},
      menubar_icon: 'demo/games/v2/casino.png',
      sequence: 1,
      items: LIVE_CASINO_MENUS,
      platform: ['desktop', 'mobile'],
      component_code: 'Menubar1'
    },
    {
      _id: '63806cad40b4a5aea422f097',
      currency: 'thb',
      title: {
        'th-TH': 'เกมไพ่',
        'en-US': 'Table Gaming',
        'zh-CN': '桌面游戏'
      },
      link: {},
      description: {},
      is_visible: true,
      is_active: true,
      is_default: false,
      menubar_icon: 'demo/games/v2/table-games.png',
      block_type: 1,
      sequence: 7,
      items: TABLE_GAME_MENUS,
      platform: ['desktop', 'mobile'],
      component_code: 'Menubar8'
    },
    {
      _id: '63806c9840b4a5aea422f05f',
      currency: 'thb',
      title: {
        'th-TH': 'หวย',
        'en-US': 'Lottery',
        'zh-CN': '彩票游戏'
      },
      link: {},
      description: {},
      is_visible: true,
      is_active: true,
      block_type: 1,
      is_default: false,
      menubar_icon: 'demo/games/v2/lottery.png',
      sequence: 8,
      items: LOTTERY_MENUS,
      platform: ['desktop', 'mobile'],
      component_code: 'Menubar4'
    },
    {
      _id: '63806cb240b4a5aea422f0a5',
      currency: 'thb',
      title: {
        'th-TH': 'ไก่ชน',
        'en-US': 'Animal',
        'zh-CN': '热门体育游戏'
      },
      link: {},
      description: {},
      is_visible: true,
      is_active: true,
      image_path: {},
      is_default: false,
      menubar_icon: 'demo/games/v2/animal.png',
      block_type: 1,
      sequence: 6,
      items: ANIMAL,
      platform: ['desktop', 'mobile'],
      component_code: 'Menubar9'
    },
    {
      _id: '63806ca340b4a5aea422f07b',
      currency: 'thb',
      title: {
        'th-TH': 'กีฬาเสมือนจริง',
        'en-US': 'Virtual Sports',
        'zh-CN': '电子体育'
      },
      link: {},
      description: {},
      is_visible: true,
      is_active: true,
      is_default: false,
      menubar_icon: 'demo/games/v2/virtual.png',
      block_type: 1,
      sequence: 5,
      items: VIRTUAL_SPORTS_MENUS,
      platform: ['desktop', 'mobile'],
      component_code: 'Menubar6'
    },
    {
      _id: '63806ca840b4a5aea422f089',
      currency: 'thb',
      title: {
        'th-TH': 'อื่นๆ',
        'en-US': 'Other',
        'zh-CN': '其他游戏'
      },
      link: {},
      description: {},
      is_visible: true,
      is_active: true,
      is_default: false,
      menubar_icon: 'demo/games/v2/other-games.png',
      block_type: 1,
      sequence: 9,
      items: OTHER_MENUS,
      platform: ['desktop', 'mobile'],
      component_code: 'Menubar7'
    },
    {
      _id: '63806c9d40b4a5aea422f06d',
      currency: 'thb',
      title: {
        'th-TH': 'กีฬา',
        'en-US': 'Sports Betting',
        'zh-CN': '体育游戏'
      },
      link: {},
      description: {},
      is_visible: true,
      is_active: true,
      is_default: false,
      menubar_icon: 'demo/games/v2/sport.png',
      block_type: 1,
      sequence: 4,
      items: SPORT_BETTING_MENUS,
      platform: ['desktop', 'mobile'],
      component_code: 'Menubar5'
    },
    {
      _id: '63806c9340b4a5aea422f051',
      currency: 'thb',
      title: {
        'th-TH': 'ยิงปลา',
        'en-US': 'Fishing',
        'zh-CN': '捕鱼游戏'
      },
      link: {},
      description: {},
      is_visible: true,
      is_active: true,
      block_type: 1,
      is_default: false,
      menubar_icon: 'demo/games/v2/fishing.png',
      sequence: 3,
      image_path: '67aedc38-f5f9-4f7a-b8ef-5bfd02f12138.png',
      items: FISHING_MENU,
      platform: ['desktop', 'mobile'],
      component_code: 'Menubar3'
    }
  ]
}

export const FLOATING_ICON_COMPONENT = {
  data: {
    type: 'main',
    data: FLOATING_ICONS
  }
}

export const CMS_REGISTRATION_IMAGE = {
  data: {
    _id: '638069adb4ed0f2d54b777fc',
    currency: 'thb',
    title: {
      'th-TH': ' ลงทะเบียน',
      'en-US': 'Registration',
      'zh-CN': '注册'
    },
    link: {},
    description: {
      'en-US': 'Register with us now and make your dreams come true!',
      'th-TH': 'description title',
      'zh-CN': '今天注册，让您的梦想成真！'
    },
    is_visible: true,
    is_active: true,
    component_code: 'RegistrationImage',
    image_path: {
      'en-US': 'demo/registration-background-en.png',
      'th-TH': 'demo/registration-background-th.png',
      'zh-CN': 'demo/registration-background-ch.png'
    },
    is_default: false,
    platform: ['desktop'],
    is_sequenceable: false,
    items: []
  }
}

export const CMS_HEADER = {
  data: {
    _id: '63803f6796d9fdac43125a3d',
    currency: 'thb',
    title: {},
    link: {},
    description: {},
    is_visible: true,
    is_active: true,
    component_code: 'HeaderLogo',
    image_path: {
      'en-US': 'demo/logo.png',
      'th-TH': 'demo/logo.png',
      'zh-CN': 'demo/logo.png'
    },
    is_default: false,
    platform: ['desktop', 'mobile'],
    is_sequenceable: false,
    items: []
  }
}

export const ARTICLE_CONTENT_1 = {
  data: {
    _id: '63bfb40f5b80bb950e648192',
    currency: 'thb',
    title: {
      'en-US': 'Live casino',
      'th-TH': 'กฎคาสิโนสด',
      'zh-CN': '真人娱乐场',
      'en-US-slug': 'live-casino',
      'th-TH-slug': 'กฎคาสโนสด',
      'zh-CN-slug': '真人娱乐场'
    },
    menubar_icon: null,
    link: {},
    description: {
      'en-US': 'Live tournamet rules and regulations',
      'th-TH': 'กฎและเงื่อนไขของคาสิโนสด',
      'zh-CN': '真人娱乐场规则和条款'
    },
    is_visible: true,
    is_active: true,
    component_code: 'ArticleContent1',
    is_default: false,
    platform: ['desktop', 'mobile'],
    is_sequenceable: false,
    items: ARTICLE_CONTENT_1_ITEMS
  }
}

export const ARTICLE_CONTENT_2 = {
  data: {
    _id: '638af9327ee6abd1b3c80e4d',
    currency: 'thb',
    title: {
      'en-US': 'Our rules',
      'th-TH': 'กฎระเบียบของเว็บ',
      'zh-CN': '网站规定',
      'en-US-slug': 'our-rules',
      'th-TH-slug': 'กฎระเบยบของเวบ',
      'zh-CN-slug': '网站规定'
    },
    menubar_icon: null,
    link: {},
    description: {
      'en-US': 'Our Rules',
      'th-TH': 'กฎระเบียบของเว็บ',
      'zh-CN': '网站规定'
    },
    is_visible: true,
    is_active: true,
    component_code: 'ArticleContent2',
    is_default: false,
    platform: ['desktop', 'mobile'],
    is_sequenceable: false,
    items: ARTICLE_CONTENT_2_ITEMS
  }
}

export const ARTICLE_CONTENT_3 = {
  data: {
    _id: '638d6ec9bb21e0a209f791a5',
    currency: 'thb',
    title: {
      'en-US': 'Slot',
      'th-TH': 'สล็อต ',
      'zh-CN': '老虎机 ',
      'en-US-slug': 'slot',
      'th-TH-slug': 'สลอต-',
      'zh-CN-slug': '老虎机-'
    },
    menubar_icon: null,
    link: {},
    description: {
      'en-US': 'Slot rules',
      'th-TH': 'กฎสล็อต ',
      'zh-CN': '老虎机规则'
    },
    is_visible: true,
    is_active: true,
    component_code: 'ArticleContent3',
    is_default: false,
    updated_at: '2025-07-14T07:03:39.805Z',
    platform: ['desktop', 'mobile'],
    is_sequenceable: false,
    items: ARTICLE_CONTENT_3_ITEMS
  }
}

export const MOBILE_BACKGROUND = {
  data: {
    _id: '638069496dfcc20df4b9dafa',
    currency: 'thb',
    title: {},
    link: {},
    description: {},
    is_visible: true,
    is_active: true,
    component_code: 'MobileBackground',
    image_path: {
      'en-US': 'demo/mobile-background-en.jpg',
      'th-TH': 'demo/mobile-background-th.png',
      'zh-CN': 'demo/mobile-background-ch.png'
    },
    is_default: false,
    platform: ['mobile'],
    is_sequenceable: false,
    items: []
  }
}

export const MOBILE_BACKGROUND_FREE = {
  data: {
    _id: '638069496dfcc20df4b9dafa',
    currency: 'thb',
    component_code: 'MobileBackground',
    image_path: {
      'en-US': 'demo/mobile-background-free-en.png',
      'th-TH': 'demo/mobile-background-free-th.png',
      'zh-CN': 'demo/mobile-background-free-ch.png'
    },
    is_default: false,
    platform: ['mobile'],
    items: []
  }
}

export const MOBILE_WHEEL = {
  data: {
    _id: '67f38fde4b6f6d5a389079ca',
    currency: 'thb',
    component_code: 'MobileGameWheelIcon',
    image_path: {
      'en-US': 'demo/wheel-icon.png',
      'th-TH': 'demo/wheel-icon.png',
      'zh-CN': 'demo/wheel-icon.png'
    },
    platform: ['mobile'],
    items: []
  }
}

export const FAVICON_RESPONSE = {
  data: {
    _id: '6380656e7e216b1819b88ec3',
    component_id: '637c4e6b8fa1c4f2cb2aab18',
    currency: 'thb',
    component_code: 'Favicon',
    image_path: 'a0d4bd2e-c1bf-446d-aa72-48d7c005529c.png'
  }
}

export const SLIDER_CONTENT_DESKTOP = SLIDER_CONTENT_DESKTOP_JSON
export const SLIDER_CONTENT_DESKTOP_FREE_THEME = SLIDER_CONTENT_DESKTOP_FREE
